import React from 'react'
import { Route, RouteComponentProps, Switch } from 'react-router'
import ProtectedRoute from './ProtectedRoute'
import Login from 'src/containers/riders/rider-portal/authentication/Login'
import MenuBar from 'src/components/riders/rider-portal/common/MenuBar'
import Footer from 'src/components/riders/rider-portal/common/Footer'
import CreateTrip from 'src/containers/riders/rider-portal/trips/create/CreateTrip'
import TripDetails from 'src/containers/riders/rider-portal/trips/details/TripDetails'

const Main = (props: RouteComponentProps) => {
  const RIDER_PORTAL_MAIN_PATH = props.match.path
  return (
    <React.Fragment>
      <MenuBar />
      <Switch>
        <Route component={Login} exact={true} path={RIDER_PORTAL_MAIN_PATH} />
        <ProtectedRoute component={CreateTrip} exact={true} path={`${RIDER_PORTAL_MAIN_PATH}/booking`} />
        <ProtectedRoute component={TripDetails} exact={true} path={`${RIDER_PORTAL_MAIN_PATH}/booking/:id`} />
      </Switch>
      <Footer />
    </React.Fragment>
  )
}

export default Main



// WEBPACK FOOTER //
// ./src/components/riders/rider-portal/Main.tsx